import jwt_decode from 'jwt-decode';
import { getSessionValue } from '@mgm/common/utils';
import { TOKEN_KEY } from '../data';
import { TTokenDetails } from '../store/authenticate/types';

export function useAuth() {
  const getIdToken = (token?: string): string | null => {
    if (token) return token;
    return getSessionValue(TOKEN_KEY, 'sessionStorage');
  };

  const isLoggedIn = (): boolean => {
    const idToken = getIdToken();
    return !!idToken;
  };

  const isTokenExpired = () => {
    const token = getIdToken();

    if (!token) {
      return true;
    }

    const tokenDetails = jwt_decode(token) as TTokenDetails;

    return (new Date(tokenDetails?.expiration)?.getTime() || 0) <= new Date().getTime();
  };

  return {
    isLoggedIn,
    isTokenExpired,
    getIdToken,
  };
}
